var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333e49;opacity:0.7;}.cls-2{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:24.24px;}.cls-3{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SPEAKER"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 500,
    cy: 500,
    r: 455.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M575.44,601c27.45-14.63,47.11-54.32,47.11-101s-19.66-86.32-47.11-100.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M526.78,428.89a87.71,87.71,0,0,1,21.6,33.36v0a109.53,109.53,0,0,1,0,75.44v0a87.71,87.71,0,0,1-21.6,33.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M630.55,367.24C661.06,382.33,683.63,436,683.63,500s-22.57,117.67-53.08,132.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M482.28,393.75v212.5a12.12,12.12,0,0,1-20.13,9.09l-56.42-49.63a24.22,24.22,0,0,0-16-6H331.94a15.62,15.62,0,0,1-15.57-15.57V455.9a15.62,15.62,0,0,1,15.57-15.57h57.79a24.22,24.22,0,0,0,16-6l56.42-49.63A12.12,12.12,0,0,1,482.28,393.75Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.cc7a8662f02319c1f98a6360fac0f7d4.svg";
export { ForwardRef as ReactComponent };